import {Template, TemplateVersion} from 'notebook/entry-templates/TemplateConstants';
import DocumentEvaluationUpdater from 'notebook/mediocre/DocumentEvaluationUpdater';
import {DocumentMapper, DocumentTraverser} from 'notebook/mediocre/DocumentTraversal';

export default class TemplateUpdater extends DocumentEvaluationUpdater<Template, TemplateVersion> {
  getDoc(item: Template): TemplateVersion {
    return item.templateVersion;
  }

  traverse(evalTraverser: DocumentTraverser, newDoc: TemplateVersion, oldDoc: TemplateVersion | null): void {
    evalTraverser.walkTemplateVersion(newDoc, oldDoc);
  }

  mapDoc(mapper: DocumentMapper, doc: TemplateVersion): TemplateVersion {
    return mapper.mapTemplateVersion(doc, null);
  }

  updatedRoot(root: Template, doc: TemplateVersion): Template {
    return {...root, templateVersion: doc};
  }
}
